module.exports = __webpack_public_path__ + "img/spacing-example-simple-details-6.9fca891f.png";